<template>
  <button
    type="button"
    class="app-bar-hit"
    :class="{ 'app-bar-hit--avatar': avatar }"
    :aria-label="ariaLabel"
    v-bind="$attrs"
  >
    <span v-if="!avatar" class="app-bar-hit__inner">
      <slot />
    </span>
    <slot v-else />
  </button>
</template>

<script>
export default {
  name: "AppBarHitButton",
  inheritAttrs: false,
  props: {
    ariaLabel: { type: String, default: "" },
    avatar: { type: Boolean, default: false },
  },
};
</script>
